export const validateNumber = (text) => {  // entrada "12000" => retorno 12000
    const regex = /^[0-9\b]+$/;
    return (regex.test(text) || text === "");
};

export const formatoDecimal = (num) => { // entrada 1234567.114 => retorno  1.234.567,11
    const voidValues = [undefined, null, NaN, ""];

    if (voidValues.includes(num)) return "";
    if (typeof num !== "string") num = num.toString();

    //if (num.includes(".")) {
    //    num = num.replace(/\./g, '');
    //}
    if (num.includes(",")) {
        num = num.replace(/\./g, '').replace(',', '.');
    }

    return formatNumber(num);
};

const formatNumber = (number) => {
    let floatNumber = parseFloat(number);
    return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(floatNumber);
};